// CevapQcKanit — kartta Cevap QC kanıtı (2026-09-15, kullanıcı isteği "kanıt ayrıntısını
// panelde göster").
//
// Kanıt tek soru için, düğmeye basınca istenir (liste yolu ağır JSON taşımaz). Kör onay
// örneğinde SoruKarti bu bileşeni hiç çizmez; sunucu da 409 döner (kanıt anahtarı ele verir).
// Kaynak: denetim_izi.kanit ← scripts/cevap_qc_paket.py (`uygula --yaz` / `kanit --yaz`).
// `Metin`: LaTeX'li metni çizen bileşen (SoruKarti LatexText verir; yoksa düz metin).
import React, { useState } from 'react';

// Protokol ADIM 4 — 9 maddelik hata avı (prompts/master/CEVAP_DOGRULAMA_QC.md).
const MADDELER = {
  1: 'Sınır değerleri',
  2: 'Negatif/geçersiz alt sınır',
  3: 'Örtük kısıtlar',
  4: 'Vaka atlama',
  5: 'Aritmetik',
  6: 'Şık tutarlılığı',
  7: 'Soru kökü mantığı',
  8: 'Metin-cebir uyumu',
  9: 'Gereksiz/çelişkili bilgi',
};
const KARAR_AD = { ONAY: '✓ ONAY', DUZELTME: '✎ DÜZELTME', RED: '✗ RED', 'KOD-KOSMADI': '? KOD KOŞMADI' };
const KARAR_RENK = {
  ONAY: 'bg-green-100 text-green-800',
  DUZELTME: 'bg-amber-100 text-amber-800',
  RED: 'bg-red-100 text-red-800',
  'KOD-KOSMADI': 'bg-gray-200 text-gray-800',
};
const YONTEM_AD = {
  'brute-force': 'brute-force (sonlu uzay tam tarandı)',
  'iki-yontem': 'iki bağımsız yöntem',
};
const PRE = 'mt-1 max-h-72 overflow-auto bg-gray-900 text-gray-100 text-[11px] leading-snug rounded p-2 whitespace-pre';

const Duz = ({ children }) => <>{children}</>;
const bos = (x) => x == null || x === '' || (Array.isArray(x) && x.length === 0);

function Bolum({ baslik, children }) {
  return (
    <div className="mt-3">
      <div className="text-[12px] font-semibold text-gray-700 mb-1">{baslik}</div>
      {children}
    </div>
  );
}

function KanitGovde({ k, iz, soru, Metin }) {
  const satilmis = String((iz && iz.sonuc) || '').startsWith('SATILMIS-RAPOR:');
  const kar = k.karsilastirma || {};
  const kor = k.kor || {};
  const kosu = k.kosu || null;
  const liste = kor.kontrol_listesi || {};
  const notlar = Array.isArray(kor.soru_yapisi_notlari) ? kor.soru_yapisi_notlari : [];
  const korMetin = kor.harf
    ? `${kor.harf} şıkkı (${kor.deger ?? '—'})`
    : (bos(kor.deger) ? '—' : `${kor.deger} — şıklarda yok`);
  const kodSatir = k.kod ? String(k.kod).split('\n').length : 0;
  return (
    <div>
      <div className="flex flex-wrap items-center gap-2">
        <span data-kanit-karar className={`px-2 py-0.5 rounded text-[12px] font-bold ${KARAR_RENK[k.karar] || 'bg-gray-100 text-gray-800'}`}>
          {KARAR_AD[k.karar] || k.karar || '—'}
        </span>
        {(k.kodlar || []).map((c) => (
          <span key={c} className="px-1.5 py-0.5 rounded bg-violet-50 text-violet-800 text-[11px] font-mono">{c}</span>
        ))}
        {iz && iz.tarih && <span className="text-[11px] text-gray-500">{new Date(iz.tarih).toLocaleString('tr-TR')}</span>}
      </div>
      {satilmis && (
        <div className="mt-2 text-[12px] text-amber-900 bg-amber-50 border border-amber-200 rounded px-2 py-1">
          Satılmış soru — içeriğe dokunulmadı; bulgu yalnız raporlandı (yayınevi düzeltme notu taslağı hazırlandı).
        </div>
      )}
      {!bos(k.gerekce) && (
        <Bolum baslik="Gerekçe">
          <div className="whitespace-pre-wrap"><Metin>{k.gerekce}</Metin></div>
        </Bolum>
      )}

      <Bolum baslik="Karşılaştırma (anahtar, kör sonuç kaydedildikten SONRA açıldı)">
        <div className="overflow-x-auto">
          <table className="text-[12px]">
            <tbody>
              <tr>
                <td className="pr-3 py-0.5 text-gray-500">Anahtar</td>
                <td>{kar.anahtar_harf || soru.dogru_cevap || '—'}
                  {kar.anahtar_sik_degeri ? <> = <Metin>{kar.anahtar_sik_degeri}</Metin></> : null}</td>
              </tr>
              <tr>
                <td className="pr-3 py-0.5 text-gray-500">Kör denetçi</td>
                <td data-kanit-kor>{korMetin}</td>
              </tr>
              <tr>
                <td className="pr-3 py-0.5 text-gray-500">Kod sonucu</td>
                <td>{kosu ? `${kosu.sonuc ?? '—'}${kosu.uyan_siklar ? ` (uyan şık: ${kosu.uyan_siklar})` : ''}` : '—'}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Bolum>

      <Bolum baslik={`Kör çözüm — ${YONTEM_AD[kor.yontem] || kor.yontem || 'yöntem belirtilmemiş'}${kor.guven ? ` · güven: ${kor.guven}` : ''}`}>
        {!bos(kor.ikinci_yontem)
          ? <div className="whitespace-pre-wrap"><Metin>{kor.ikinci_yontem}</Metin></div>
          : <div className="text-gray-500">—</div>}
      </Bolum>

      <Bolum baslik="9 maddelik hata avı">
        <ol className="list-none pl-0 space-y-1">
          {Object.keys(MADDELER).map((m) => (liste[m] ? (
            <li key={m} data-kanit-madde={m}>
              <span className="font-semibold">{m}. {MADDELER[m]}:</span> <Metin>{String(liste[m])}</Metin>
            </li>
          ) : null))}
        </ol>
      </Bolum>

      {notlar.length > 0 && (
        <Bolum baslik="Soru yapısı notları">
          <ul className="list-none pl-0 space-y-1">
            {notlar.map((n, i) => (
              <li key={i} className={n && n.etki === 'cevap' ? 'text-red-800' : 'text-gray-600'}>
                <span className="font-semibold">{n && n.etki === 'cevap' ? 'Cevabı etkiler' : 'Biçim'}{n && n.madde ? ` (madde ${n.madde})` : ''}:</span>{' '}
                <Metin>{String((n && n.not) || '')}</Metin>
              </li>
            ))}
          </ul>
        </Bolum>
      )}

      {k.duzeltme && (
        // Yalnız uygulanmış DÜZELTME "yapılan"dır; satılmış soruya dokunulmaz, RED revize
        // hattına gider — oradaki düzeltme bir ÖNERİDİR (canlı #49 ölçümüyle bulundu).
        <Bolum baslik={k.karar === 'DUZELTME' && !satilmis
          ? 'Yapılan düzeltme'
          : `Önerilen düzeltme (uygulanmadı${satilmis ? ' — satılmış soru' : ''})`}>
          {!bos(k.duzeltme.aciklama) && <div className="whitespace-pre-wrap"><Metin>{k.duzeltme.aciklama}</Metin></div>}
          {!bos(k.duzeltme.alanlar) && (
            <div className="text-[12px] text-gray-500 mt-1">Değişen alanlar: <span className="font-mono">{k.duzeltme.alanlar.join(', ')}</span></div>
          )}
        </Bolum>
      )}
      {k.ikinci_tur && (
        <Bolum baslik="İkinci kör tur (düzeltilmiş hâl)">
          <div>{k.ikinci_tur.eslesti ? '✓ Eşleşti' : '✗ Eşleşmedi'}{k.ikinci_tur.kor_sonuc ? ` — kör sonuç: ${k.ikinci_tur.kor_sonuc}` : ''}</div>
          {!bos(k.ikinci_tur.not) && <div className="text-[12px] text-gray-500 mt-1">{k.ikinci_tur.not}</div>}
        </Bolum>
      )}

      {kosu && (
        <Bolum baslik={`Kod koşusu — orkestratör kodu yeniden koştu (çıkış kodu ${kosu.rc ?? '—'})`}>
          <pre data-kanit-cikti className={PRE}>{kosu.cikti || '(çıktı yok)'}</pre>
          {!bos(kosu.hata) && <pre className={`${PRE} text-red-200`}>{kosu.hata}</pre>}
        </Bolum>
      )}
      {k.kod && (
        <details className="mt-3">
          <summary className="cursor-pointer text-[12px] font-semibold text-gray-700">Doğrulama kodu (Python, {kodSatir} satır)</summary>
          <pre data-kanit-kod className={PRE}>{k.kod}</pre>
        </details>
      )}
      <div className="text-[11px] text-gray-400 mt-2">
        Protokol {(k.protokol_sha || (iz && iz.protokol_sha) || '').slice(0, 12) || '—'}{k.paket ? ` · ${k.paket}` : ''}
      </div>
    </div>
  );
}

export default function CevapQcKanit({ soru, onKanit, Metin = Duz }) {
  const [acik, setAcik] = useState(false);
  const [veri, setVeri] = useState(null);
  const [hata, setHata] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);
  if (!soru || !soru.cevap_qc || !onKanit) return null;

  const ac = async () => {
    const yeni = !acik;
    setAcik(yeni);
    if (!yeni || veri || yukleniyor) return;
    setYukleniyor(true);
    setHata('');
    try {
      setVeri(await onKanit(soru));
    } catch (e) {
      setHata((e && e.message) || String(e));
    } finally {
      setYukleniyor(false);
    }
  };

  const k = veri && veri.kanit;
  return (
    <div data-cevap-qc-kanit className="mt-3 border-t border-gray-100 pt-3 text-[13px] text-gray-700">
      <button type="button" data-kanit-ac onClick={ac} aria-expanded={acik}
        className="text-violet-700 hover:text-violet-900 font-semibold cursor-pointer">
        🔍 Cevap QC kanıtı {acik ? '▴' : '▾'}
      </button>
      {acik && (
        <div className="mt-2">
          {yukleniyor && <div className="text-gray-500">Kanıt yükleniyor…</div>}
          {hata && <div className="text-red-700">{hata}</div>}
          {veri && !k && (
            <div className="text-gray-500">
              Bu iz için ayrıntılı kanıt kaydı yok{veri.iz && veri.iz.sonuc ? ` (karar: ${veri.iz.sonuc})` : ''}.
            </div>
          )}
          {k && <KanitGovde k={k} iz={veri.iz} soru={soru} Metin={Metin} />}
        </div>
      )}
    </div>
  );
}
